"use client"

import { useState, useEffect } from "react"
import { useAppContext } from "../context/AppContext"
import "./PaymentsPage.css"
import ShiftModal from "../components/ShiftModal"
import { AiOutlineLoading } from "react-icons/ai"

const PaymentsPage = () => {
  const currentDate = new Date()
  const [selectedDate, setSelectedDate] = useState(new Date())

  const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth())
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear())
  const [monthlyData, setMonthlyData] = useState({
    totalAmount: 0,
    paidAmount: 0,
    pendingAmount: 0,
    tagSummaries: [],
    shifts: [],
  })
  const [shiftsArr, setShiftArr] = useState([]) 

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingShift, setEditingShift] = useState(null)

  const handleEditShift = (shift) => {
    setEditingShift(shift)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setEditingShift(null)
  }


  const { shifts, tags, getShiftsForMonth, loadingApp } = useAppContext()
  var completeArr = []
  
const refreshData = () => {
  setShiftArr([])

  const monthShifts = getShiftsForMonth(selectedMonth, selectedYear)

  
    // Calculate totals
    let total = 0
    let paid = 0
    let pending = 0

    // Group by tag
    const tagGroups = {}


    completeArr = []

    monthShifts.forEach((shift) => {
      console.log(shift);
      
      const tag = tags.find((t) => t.id === shift.tagId)
      if (!tag) return

      const amount = shift.value ? shift.value : tag.paymentAmount
      total += amount

      if (shift.paid) {
        paid += amount
      } else {
        pending += amount
      }

      // Add to tag group
      if (!tagGroups[tag.id]) {
        tagGroups[tag.id] = {
          id: tag.id,
          name: tag.name,
          color: tag.color,
          count: 0,
          paidCount: 0,
          pendingCount: 0,
          totalAmount: 0,
        }
      }

      completeArr.push({...shift, ...tag})

      tagGroups[tag.id].count += 1
      tagGroups[tag.id].totalAmount += amount

      if (shift.paid) {
        tagGroups[tag.id].paidCount += 1
      } else {
        tagGroups[tag.id].pendingCount += 1
      }
    })

    const newArr = completeArr.length > 0 ? (completeArr.sort((a, b) => new Date(a.date) - new Date(b.date))) : 0;

    setShiftArr(newArr)

    setMonthlyData({
      totalAmount: total,
      paidAmount: paid,
      pendingAmount: pending,
      tagSummaries: Object.values(tagGroups),
    })
}

  useEffect(() => {
    refreshData()

  }, [selectedMonth, selectedYear, shifts, tags, getShiftsForMonth])

  const months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ]

  // Generate years (current year and 5 years back)
  const years = Array.from({ length: 6 }, (_, i) => currentDate.getFullYear() + 1 - i)

  return (
    <div className="payments-page">
      <h1 className="page-title">Pagamentos</h1>
      {loadingApp && <div className="loading"><AiOutlineLoading size="50px"/></div>}
      <div className="filters-container">
        <div className="form-group">
          <label className="form-label">Mês</label>
          <select
            className="form-control"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(Number.parseInt(e.target.value))}
          >
            {months.map((month, index) => (
              <option onChange={() => {refreshData()}} key={index} value={index}>
                {month}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Ano</label>
          <select
            className="form-control"
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number.parseInt(e.target.value))}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="summary-cards">
        <div className="summary-card">
          <div className="summary-card-title">Total</div>
          <div className="summary-card-value">R$ {monthlyData.totalAmount.toFixed(2)}</div>
          <div className="summary-card-subtitle">Valor total do mês</div>
        </div>

        <div className="summary-card">
          <div className="summary-card-title">Pago</div>
          <div className="summary-card-value paid">R$ {monthlyData.paidAmount.toFixed(2)}</div>
          <div className="summary-card-subtitle">Valor já recebido</div>
        </div>

        <div className="summary-card">
          <div className="summary-card-title">Pendente</div>
          <div className="summary-card-value pending">R$ {monthlyData.pendingAmount.toFixed(2)}</div>
          <div className="summary-card-subtitle">Valor a receber</div>
        </div>
      </div>

      <div className="tag-summaries-container">
        <h2 className="section-title">Detalhamento por Etiqueta</h2>

        {monthlyData.tagSummaries.length > 0 ? (
          <div className="tag-summaries">
            {monthlyData.tagSummaries.map((tagSummary) => (
              <div className="tag-summary-card" key={tagSummary.id}>
                <div className="tag-summary-header">
                  <div className="tag-color" style={{ backgroundColor: tagSummary.color }}></div>
                  <div className="tag-name">{tagSummary.name}</div>
                </div>

                <div className="tag-summary-details">
                  <div className="tag-summary-item">
                    <div className="tag-summary-label">Plantões</div>
                    <div className="tag-summary-value">{tagSummary.count}</div>
                  </div>

                  <div className="tag-summary-item">
                    <div className="tag-summary-label">Valor por plantão</div>
                    <div className="tag-summary-value">R$ {(tagSummary.totalAmount / tagSummary.count).toFixed(2)}</div>
                  </div>

                  <div className="tag-summary-item">
                    <div className="tag-summary-label">Total</div>
                    <div className="tag-summary-value">R$ {tagSummary.totalAmount.toFixed(2)}</div>
                  </div>
                </div>

                <div className="tag-summary-status">
                  <div className="status-item">
                    <div className="status-label">Pagos:</div>
                    <div className="status-value">{tagSummary.paidCount}</div>
                  </div>

                  <div className="status-item">
                    <div className="status-label">Pendentes:</div>
                    <div className="status-value">{tagSummary.pendingCount}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-data">
            <p>Nenhum plantão encontrado para o período selecionado</p>
          </div>
        )}
      </div>

      <div className="tag-summaries-container">
        <h2 className="section-title">Plantões</h2>
        {shiftsArr.length > 0 ? (
          <div className="shifts-list">
            {shiftsArr.map((shift, index) => (
              <div key={shift.id + index} className="shift-card" style={{borderLeft: `10px solid ${shift.paid ? "#28a745" : "#dc3545"}`}}>
                <div className="shift-infosline">
                  <div>Dia {shift.date.split("-")[2] } {shift.time ? <> - {shift.startTime} às {shift.endTime}</> : <> - Horário não informado </>}</div>
                  <div>R$ {shift.value ? shift.value : shift.paymentAmount}</div>
                </div>
                <div className="shift-infosline">
                  <div><b> {shift.name}</b></div>
                  <div className={`btn-paid ${shift.paid ? "Pago" : "Não Pago"}`} id={shift.paid ? "paid" : "notpaid"}>{shift.paid ? "Pago" : "Não Pago"}</div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-data">
            <p>Nenhum plantão encontrado para o período selecionado</p>
          </div>
        )}
      </div>   
     
    </div>
  )
}

export default PaymentsPage

